(function () {
  function initializeProductsMegaMenu(menu) {
    if (!menu || menu.dataset.productsMegaInitialized === 'true') return;

    var trigger = menu.querySelector('[data-products-mega-trigger]');
    var panel = menu.querySelector('[data-products-mega-panel]');
    var header = menu.closest('#__globalHeader');
    var closeTimer;

    if (!trigger || !panel) return;

    function clearCloseTimer() {
      if (!closeTimer) return;

      window.clearTimeout(closeTimer);
      closeTimer = null;
    }

    function setOpen(isOpen) {
      clearCloseTimer();
      menu.classList.toggle('is-open', isOpen);
      trigger.setAttribute('aria-expanded', String(isOpen));

      if (header) {
        var fillDesktopHeader =
          isOpen && window.matchMedia('(min-width: 1025px)').matches;
        header.classList.toggle('products-mega-menu-open', fillDesktopHeader);
      }
    }

    function scheduleClose() {
      clearCloseTimer();
      closeTimer = window.setTimeout(function () {
        if (!menu.matches(':hover') && !menu.contains(document.activeElement)) {
          setOpen(false);
        }
      }, 400);
    }

    menu.addEventListener('pointerenter', function () {
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

      clearCloseTimer();
      setOpen(true);
    });

    menu.addEventListener('pointerleave', function () {
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

      scheduleClose();
    });

    panel.addEventListener('pointerenter', function () {
      clearCloseTimer();
      setOpen(true);
    });

    menu.addEventListener('focusin', function (event) {
      if (
        window.matchMedia('(min-width: 1025px)').matches ||
        event.target !== trigger
      ) {
        setOpen(true);
      }
    });

    menu.addEventListener('focusout', function () {
      window.setTimeout(function () {
        if (!menu.contains(document.activeElement)) scheduleClose();
      }, 0);
    });

    trigger.addEventListener('click', function () {
      setOpen(!menu.classList.contains('is-open'));
    });

    menu.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;

      setOpen(false);
      trigger.focus();
    });

    document.addEventListener('click', function (event) {
      if (!menu.contains(event.target)) setOpen(false);
    });

    menu.dataset.productsMegaInitialized = 'true';
  }

  function initializeAll(scope) {
    scope.querySelectorAll('[data-products-mega-menu]').forEach(initializeProductsMegaMenu);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initializeAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
